"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _RowTwoCol = _interopRequireDefault(require("../../LayoutContainers/RowTwoCol"));

var _Button = _interopRequireDefault(require("../Button"));

var _strings = require("../../../constants/strings");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function () { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var binaryChoicePositiveText = _strings.binaryChoiceDefaultText.binaryChoicePositiveText,
    binaryChoiceNegativeText = _strings.binaryChoiceDefaultText.binaryChoiceNegativeText;
/**
 * Used on pages that require a 'yes' or 'no' response.
 *
 * These buttons will always display in the primaryGhost button style.
*/

var BinaryChoice = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(BinaryChoice, _React$PureComponent);

  var _super = _createSuper(BinaryChoice);

  function BinaryChoice() {
    _classCallCheck(this, BinaryChoice);

    return _super.apply(this, arguments);
  }

  _createClass(BinaryChoice, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          affirmativeResponseText = _this$props.affirmativeResponseText,
          choiceHandler = _this$props.choiceHandler,
          className = _this$props.className,
          dataTestId = _this$props.dataTestId,
          negativeResponseText = _this$props.negativeResponseText;
      return /*#__PURE__*/_react.default.createElement(_RowTwoCol.default, {
        className: className,
        dataTestId: dataTestId
      }, /*#__PURE__*/_react.default.createElement(_Button.default, {
        dataTestId: "binary-choice-positive-choice-button",
        className: "c-affirmative-button",
        onClick: function onClick() {
          return choiceHandler(true);
        },
        childkey: "leftContent",
        colorTheme: "primaryGhost"
      }, affirmativeResponseText), /*#__PURE__*/_react.default.createElement(_Button.default, {
        dataTestId: "binary-choice-negative-choice-button",
        className: "c-negative-button",
        onClick: function onClick() {
          return choiceHandler(false);
        },
        childkey: "rightContent",
        colorTheme: "primaryGhost"
      }, negativeResponseText));
    }
  }]);

  return BinaryChoice;
}(_react.default.PureComponent);

_defineProperty(BinaryChoice, "propTypes", {
  /** Text for the 'yes' button */
  affirmativeResponseText: _propTypes.default.string,

  /** Styling classname */
  className: _propTypes.default.string,

  /** Returns either choice back with a true/false respectively */
  choiceHandler: _propTypes.default.func.isRequired,

  /** Testing hook dom attribute */
  dataTestId: _propTypes.default.string.isRequired,

  /** Text for the 'no' button */
  negativeResponseText: _propTypes.default.string
});

_defineProperty(BinaryChoice, "defaultProps", {
  affirmativeResponseText: binaryChoicePositiveText(),
  className: '',
  negativeResponseText: binaryChoiceNegativeText()
});

var _default = BinaryChoice;
exports.default = _default;